/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-use-before-define */
/* eslint-disable no-param-reassign */
// DEPENDENCIES
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useFormik } from 'formik';
import { useParams } from 'react-router-dom';
// COMPONENTS
// ICONS
// CUSTOM COMPONENTS
import Overlay from '../../../../../components/Overlay';
import Section from '../../../../../components/Section';
import ContentBlock from '../../../../../components/ContentBlock';
import CustomBlock from '../../../../../components/CustomBlock';
import FormBlock from '../../../../../components/FormBlock';
import CheckboxBlock from '../../../../../components/CheckboxBlock';
import ContentHeader from '../../../../../components/ContentHeader';
import InputBlock from '../../../../../components/InputBlock';
import Button from '../../../../../components/Button';
// REDUX
import * as alert from '../../../../../redux/alertToastRedux';
import * as confirmModal from '../../../../../redux/confirmModalRedux';
// SERVICES AND HELPERS
import * as clientService from '../../../../../services/management/clientService';
import ClientValidator from '../../../../../helpers/validators/management/client/ClientValidator';
import * as helper from '../../../../../helpers/helper';

const initialClientModel = {
  id: 0,
  name: '',
  contactName: '',
  contactPhone: '',
  contactEmail: '',
  address1: '',
  address2: '',
  city: '',
  state: '',
  zipCode: '',
  country: '',
  isActive: true,
  menus: []
};

const ClientManagementPage = (props) => {
  const {
    showAlert,
    history,
  } = props;
  const { clientId } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [client, setClient] = useState(initialClientModel);

  useEffect(() => {
    if (clientId) {
      populateForm();
    }
  }, []);

  const formik = useFormik({
    initialValues: client,
    validationSchema: ClientValidator,
    enableReinitialize: true,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
      if (clientId) {
        updateClient(values);
      } else {
        createClient(values);
      }
    },
  });

  const populateForm = () => {
    setIsLoading(true);
    clientService.getClientById(clientId).then((res) => {
      setClient(res.client);
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'error' });
    }).finally(() => {
      setIsLoading(false);
    });
  };

  const createClient = (model) => {
    setIsLoading(true);
    clientService.createClient(model).then((res) => {
      showAlert({ text: res.message, state: 'success' });
      history.push(`/management/client/edit/${res.id}`);
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'warning' });
    }).finally(() => setIsLoading(false));
  };

  const updateClient = (model) => {
    setIsLoading(true);
    clientService.updateClient(model).then((res) => {
      showAlert({ text: res.message, state: 'success' });
    }).catch((ex) => {
      showAlert({ text: ex.message, state: 'warning' });
    }).finally(() => setIsLoading(false));
  };

  return (
    <>
      {isLoading && <Overlay hasLoader />}
      <CustomBlock className="content-container--padded">
        <Section isFullWidth>
          <FormBlock className="content-container--card-style--with-shadow" onSubmit={formik.handleSubmit}>
            <ContentHeader
              title="Customer Details"
              headerSize="lg"
            />

            <Section hasNoContainer>
              <ContentBlock>
                <ContentHeader
                  title="Basic Information"
                  headerSize="md"
                  className="alt-font fw-600 primary-lighter--clr"
                />
              </ContentBlock>

              <ContentBlock cols={3}>
                <InputBlock
                  label="Customer Name"
                  isRequired
                  errorMessage={formik.errors.name}
                  inputState={`${helper.getInputClasses(formik, 'name')}`}
                  {...formik.getFieldProps('name')}
                />
              </ContentBlock>

              <ContentBlock cols={3}>
                <InputBlock
                  label="Customer No."
                  isRequired
                  errorMessage={formik.errors.clientNo}
                  inputState={`${helper.getInputClasses(formik, 'clientNo')}`}
                  {...formik.getFieldProps('clientNo')}
                />
              </ContentBlock>

              <ContentBlock>
                <CheckboxBlock
                  label="Is active?"
                  id="isActive"
                  {...formik.getFieldProps('isActive')}
                  isChecked={formik.values.isActive}
                />
              </ContentBlock>

              <ContentBlock className="mt-30">
                <ContentHeader
                  title="Contact Information"
                  headerSize="md"
                  className="alt-font fw-600 alt--clr primary-lighter--clr"
                />
              </ContentBlock>

              <ContentBlock cols={3}>
                <InputBlock
                  label="Contact Name"
                  placeholder="e.g. John Doe"
                  errorMessage={formik.errors.contactName}
                  inputState={`${helper.getInputClasses(formik, 'contactName')}`}
                  {...formik.getFieldProps('contactName')}
                />
              </ContentBlock>

              <ContentBlock cols={3}>
                <InputBlock
                  label="Contact Phone"
                  placeholder="e.g. (999)999-9999"
                  mask="(999)999-9999"
                  errorMessage={formik.errors.contactPhone}
                  inputState={`${helper.getInputClasses(formik, 'contactPhone')}`}
                  {...formik.getFieldProps('contactPhone')}
                />
              </ContentBlock>

              <ContentBlock cols={3}>
                <InputBlock
                  label="Contact Email"
                  placeholder="e.g. john.doe@kandb.net"
                  errorMessage={formik.errors.contactEmail}
                  inputState={`${helper.getInputClasses(formik, 'contactEmail')}`}
                  {...formik.getFieldProps('contactEmail')}
                />
              </ContentBlock>

              <ContentBlock className="mt-30">
                <ContentHeader
                  title="Location Information"
                  headerSize="md"
                  className="alt-font fw-600 alt--clr primary-lighter--clr"
                />
              </ContentBlock>

              <ContentBlock cols={2}>
                <InputBlock
                  label="Street Address"
                  placeholder="e.g. 3900 N Causeway Blvd"
                  errorMessage={formik.errors.address1}
                  inputState={`${helper.getInputClasses(formik, 'address1')}`}
                  {...formik.getFieldProps('address1')}
                />
              </ContentBlock>

              <ContentBlock cols={3}>
                <InputBlock
                  label="Suite/Unit/Bldg No."
                  placeholder="e.g. #1350"
                  errorMessage={formik.errors.address2}
                  inputState={`${helper.getInputClasses(formik, 'address2')}`}
                  {...formik.getFieldProps('address2')}
                />
              </ContentBlock>

              <ContentBlock cols={2}>
                <InputBlock
                  label="City"
                  placeholder="e.g. New Orleans"
                  errorMessage={formik.errors.city}
                  inputState={`${helper.getInputClasses(formik, 'city')}`}
                  {...formik.getFieldProps('city')}
                />
              </ContentBlock>

              <ContentBlock cols={2}>
                <InputBlock
                  label="State"
                  placeholder="e.g. Louisiana"
                  errorMessage={formik.errors.state}
                  inputState={`${helper.getInputClasses(formik, 'state')}`}
                  {...formik.getFieldProps('state')}
                />
              </ContentBlock>

              <ContentBlock cols={1}>
                <InputBlock
                  label="Zip Code"
                  placeholder="e.g. 70002"
                  mask="99999"
                  errorMessage={formik.errors.zipCode}
                  inputState={`${helper.getInputClasses(formik, 'zipCode')}`}
                  {...formik.getFieldProps('zipCode')}
                />
              </ContentBlock>
              
              <ContentBlock cols={2}>
                <InputBlock
                  label="Country"
                  placeholder="e.g. USA"
                  errorMessage={formik.errors.country}
                  inputState={`${helper.getInputClasses(formik, 'country')}`}
                  {...formik.getFieldProps('country')}
                />
              </ContentBlock>

              <ContentBlock className="content-container--actions flex-end">
                <Button
                  text="Cancel"
                  className="danger--bg"
                  onClick={() => {
                    history.goBack();
                  }}
                />

                <Button
                  text={clientId ? 'Save Changes' : 'Create'}
                  className="primary--bg"
                  onClick={formik.handleSubmit}
                />
              </ContentBlock>
            </Section>
          </FormBlock>
        </Section>
      </CustomBlock>
    </>
  );
};

const mapStateFromProps = (state) => ({ auth: state.auth });

export default connect(mapStateFromProps, {
  ...alert.actions,
  ...confirmModal.actions
})(ClientManagementPage);